import {
  EditContextProvider,
  Form,
  SaveButton,
  useEditController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import {
  Button as MUIButton,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Resources } from '../resource';
import HotSearchForm from './HotSearchForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const EditHotSearch = ({ id, onClose }: { id: string | number; onClose: () => void }) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useEditController({
    id,
    resource: Resources.hotSearch,
    mutationMode: 'pessimistic',
    mutationOptions: {
      onSuccess: () => {
        notify(t('module.hot-search.updateSuccess'), { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        const errorCode = error?.body?.code || error?.code;
        switch (errorCode) {
          default:
            notify(error?.message || t('module.hot-search.updateFailed'), {
              type: 'error',
            });
            break;
        }
      },
    },
  });

  if (controller.isLoading || !controller.record) return null;

  return (
    <EditContextProvider value={controller}>
      <Form disableInvalidFormNotification>
        <DialogTitle>{t('module.hot-search.editConfiguration')}</DialogTitle>
        <DialogContent>
          <HotSearchForm isCreate={false} />
        </DialogContent>
        <DialogActions>
          <MUIButton
            variant="outlined"
            onClick={() => {
              onClose();
            }}
          >
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="hotSearching" action="create">
            <SaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </EditContextProvider>
  );
};

export default EditHotSearch;






